// extracted by mini-css-extract-plugin
export default {"wrapper":"VB","content":"WB","firstSection":"XB","text":"YB","table":"ZB","tableText":"aC","row":"bC","column_2":"cC","column_1":"eC","column_3":"fC"};
    if(module.hot) {
      // 1713211520716
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  